module.exports = __webpack_public_path__ + "img/icone-dashboard.419b7782.png";